module.exports = __webpack_public_path__ + "VectipedeBk-Regular-da831c33b1edabb3535fb899187e7146.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/VectipedeBk-Regular.ttf
// module id = 171
// module chunks = 1